import { SaleOrderLineProduct } from './sale-order-line-product';
import { SaleOrderLineComplement } from './sale-order-line-complement';
import { SaleOrderLineOther } from './sale-order-line-other';

export const TYPE_PRODUCT = 1;
export const TYPE_COMPLEMENT = 2;
export const TYPE_OTHER = 3;

export class SaleOrderLine {
  constructor(
    public hash?: string,
    public type?: number,
    public position?: number,
    public saleOrderLineProduct?: SaleOrderLineProduct,
    public saleOrderLineComplement?: SaleOrderLineComplement,
    public saleOrderLineOther?: SaleOrderLineOther

  ) { }

  get isTypeProduct() {
    return this.type === TYPE_PRODUCT;
  }

  get isTypeComplement() {
    return this.type === TYPE_COMPLEMENT;
  }

  get isTypeOther() {
    return this.type === TYPE_OTHER;
  }

  clone() {
    return new SaleOrderLine(
      this.hash,
      this.type,
      this.position,
      this.saleOrderLineProduct,
      this.saleOrderLineComplement,
      this.saleOrderLineOther
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-order-line.ts